import React from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home/Home";
import ServicesPage from "./pages/Services/Services";
import ServiceDetail from "./pages/Services/ServiceDetail";
import ResultsPage from "./pages/Results/Results";
import AboutPage from "./pages/About/About";
import ContactPage from "./pages/Contact/Contact";

import CaseStudy from "./pages/CaseStudy/Case";
import CaseStudies from "./pages/Casestudies/Casestudies";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <HashRouter>

      <div className="App">
        <ScrollToTop />

        <Header />

        <Routes>

          {/* Home */}
          <Route
            path="/"
            element={<Home />}
          />

          {/* Services */}
          <Route
            path="/services"
            element={<ServicesPage />}
          />

          <Route
            path="/services/:slug"
            element={<ServiceDetail />}
          />

          {/* Results */}
          <Route
            path="/casestudies"
            element={<CaseStudies />}
          />

          {/* About */}
          <Route
            path="/about"
            element={<AboutPage />}
          />

          {/* Contact */}
          <Route
            path="/contact"
            element={<ContactPage />}
          />

          {/* Individual Case Studies */}
          <Route
            path="/case-studies/:slug"
            element={<CaseStudy />}
          />

        </Routes>

        <Footer />

      </div>

    </HashRouter>
  );
}

export default App;